import { Pipe, PipeTransform } from '@angular/core';
import { ValidEmailRegex } from '@marmon/shared/types/user';

@Pipe({ name: 'validEmail', standalone: true })
export class ValidEmailPipe implements PipeTransform {
	transform(email: string) {
		return ValidEmailRegex.test(email);
	}
}
